<template>
  <div class="home">
    <BackToTop />
    <div class="container">
      <!-- 轮播图 -->
      <BannerCarousel
        :banners="banners"
        :topNewsList="topNewsList"
        :showLanguageSwitch="true"
      />
      <!-- 品牌热点 -->
      <div class="plate">
        <div class="plate_left">
          <div class="title">品牌热点</div>
          <div class="main_plate">
            <div class="main_plate_item" v-if="reDian.bannerList.length">
              <div
                class="main_plate_itemTop"
                @click="goToDetail(reDian.bannerList[0].id)"
              >
                <img :src="reDian.bannerList[0].cover_img" alt="" />
                <span :class="{ bold: reDian.bannerList[0].is_bold === 1 }">{{
                  reDian.bannerList[0].title
                }}</span>
              </div>
              <div class="main_plate_itemBottom">
                <div
                  class="main_plate_itemBottom_item"
                  v-for="(item, index) in reDian.bannerList.slice(1, 3)"
                  :key="index"
                  @click="goToDetail(item.id)"
                >
                  <img :src="item.cover_img" alt="" />
                  <span :class="{ bold: item.is_bold === 1 }">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="(item, index) in reDian.newsList"
                :key="item.id || index"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <div class="plate_right" v-if="reDian.classSonList.length">
          <div
            class="plate_right_item"
            v-for="(item, index) in reDian.classSonList"
            :key="index"
          >
            <div class="plate_right_item_title">
              <span>{{ item.name }}</span>
            </div>
            <div class="plate_right_item_content">
              <a
                :href="item.url"
                target="_blank"
                class="plate_right_item_content_item"
              >
                <img :src="item.img" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <ScrollBanner :heZuo="heZuo" /> -->
      <!-- 品牌出海 -->
      <div class="plate">
        <div class="plate_left">
          <div class="title">品牌出海</div>
          <div class="main_plate">
            <div class="main_plate_item" v-if="chuHai.bannerList.length">
              <div
                class="main_plate_itemTop"
                @click="goToDetail(chuHai.bannerList[0].id)"
              >
                <img :src="chuHai.bannerList[0].cover_img" alt="" />
                <span :class="{ bold: chuHai.bannerList[0].is_bold === 1 }">{{
                  chuHai.bannerList[0].title
                }}</span>
              </div>
              <div class="main_plate_itemBottom">
                <div
                  class="main_plate_itemBottom_item"
                  v-for="(item, index) in chuHai.bannerList.slice(1, 3)"
                  :key="index"
                  @click="goToDetail(item.id)"
                >
                  <img :src="item.cover_img" alt="" />
                  <span :class="{ bold: item.is_bold === 1 }">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="(item, index) in chuHai.newsList"
                :key="item.id || index"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <div class="plate_right" v-if="chuHai.classSonList.length">
          <div
            class="plate_right_item"
            v-for="(item, index) in chuHai.classSonList"
            :key="index"
          >
            <div class="plate_right_item_title">
              <span>{{ item.name }}</span>
            </div>
            <div class="plate_right_item_content">
              <a
                :href="item.url"
                target="_blank"
                class="plate_right_item_content_item"
              >
                <img :src="item.img" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 图片区域 -->
      <div class="photo_banner">
        <div class="photo_banner_item photo_banner_headline">
          <img src="../assets/Headline.png" alt="" />
        </div>
        <div
          class="photo_banner_item photo_banner_photo"
          v-for="item in faBu.img_list"
          :key="item.id"
        >
          <a :href="item.url" target="_blank">
            <img :src="item.img" alt="" />
          </a>
          <!-- <span class="photo_text" v-if="index === 0"
            >2023中国白酒品牌价值评价结果发布</span
          >
          <span class="photo_text" v-else-if="index === 1"
            >2023世界蒸馏酒<br />十大产区发布</span
          >
          <span class="photo_text" v-else-if="index === 2"
            >2023世界蒸馏酒<br />品牌榜结果发布</span
          > -->
        </div>
      </div>
      <!-- 老字号品牌 -->
      <div class="plate" style="margin-bottom: 83px">
        <div class="plate_left">
          <div class="title">老字号品牌</div>
          <div class="main_plate">
            <div class="main_plate_item" v-if="pinPai.bannerList.length">
              <div
                class="main_plate_itemTop"
                @click="goToDetail(pinPai.bannerList[0].id)"
              >
                <img :src="pinPai.bannerList[0].cover_img" alt="" />
                <span :class="{ bold: pinPai.bannerList[0].is_bold === 1 }">{{
                  pinPai.bannerList[0].title
                }}</span>
              </div>
              <div class="main_plate_itemBottom">
                <div
                  class="main_plate_itemBottom_item"
                  v-for="(item, index) in pinPai.bannerList.slice(1, 3)"
                  :key="index"
                  @click="goToDetail(item.id)"
                >
                  <img :src="item.cover_img" alt="" />
                  <span :class="{ bold: item.is_bold === 1 }">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="(item, index) in pinPai.newsList"
                :key="item.id || index"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <div
          class="plate_right"
          style="margin-top: 65px"
          v-if="pinPai.classSonList.length"
        >
          <div
            class="plate_right_item"
            v-for="(item, index) in pinPai.classSonList"
            :key="index"
          >
            <div class="plate_right_item_content">
              <a
                :href="item.url"
                target="_blank"
                class="plate_right_item_content_item"
              >
                <img :src="item.img" alt="" />
              </a>
            </div>
            <div class="laozihao_item_title">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 品牌论坛 -->
      <div class="plate" style="margin-bottom: 83px">
        <div class="plate_left">
          <div class="title">生态品牌</div>
          <div class="main_plate">
            <div class="main_plate_item" v-if="lunTan.bannerList.length">
              <div
                class="main_plate_itemTop"
                @click="goToDetail(lunTan.bannerList[0].id)"
              >
                <img :src="lunTan.bannerList[0].img" alt="" />
                <span :class="{ bold: lunTan.bannerList[0].is_bold === 1 }">{{
                  lunTan.bannerList[0].title
                }}</span>
              </div>
              <div class="main_plate_itemBottom">
                <div
                  class="main_plate_itemBottom_item"
                  v-for="(item, index) in lunTan.bannerList.slice(1, 3)"
                  :key="index"
                  @click="goToDetail(item.id)"
                >
                  <img :src="item.img" alt="" />
                  <span :class="{ bold: item.is_bold === 1 }">{{
                    item.title
                  }}</span>
                </div>
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="(item, index) in lunTan.newsList"
                :key="item.id || index"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <div class="plate_right" style="gap: 10px">
          <div class="plate_right_item">
            <div class="plate_right_item_title">
              <span>品牌官说</span>
            </div>
            <div class="plate_right_item_content" v-if="lunTan.guanShuo[0]">
              <div class="plate_right_item_content_item">
                <img :src="getFullUrl(lunTan.guanShuo[0].cover_img)" alt="" />
              </div>
            </div>
          </div>
          <div class="main_plate_news">
            <span
              v-for="(item, index) in lunTan.guanShuo"
              :key="item.id || index"
              :class="item.is_bold === 1 ? 'news2' : 'news1'"
              @click="goToDetail(item.id)"
              >{{ item.title }}</span
            >
          </div>
        </div>
      </div>
      <!-- 专题报道 -->
      <!-- <div class="plate zhuanti" style="margin-bottom: 95px">
        <div class="title">专题报道</div>
        <div
          class="zhuan_item"
          v-for="rowIndex in Math.ceil(baoDao.imgList.length / 4)"
          :key="rowIndex"
          :style="rowIndex === 1 ? 'margin-bottom: 53px' : ''"
        >
          <div class="zhuan_item_content">
            <a
              v-for="(item, index) in baoDao.imgList.slice(
                (rowIndex - 1) * 4,
                rowIndex * 4
              )"
              :key="item.id || index"
              :href="item.url"
              target="_blank"
              :class="[
                index === 0
                  ? 'zhuan_item_box1'
                  : index === 3
                  ? 'zhuan_item_box3'
                  : 'zhuan_item_box2',
                'zhuan_item_box_bg',
              ]"
              :style="item.img ? { backgroundImage: `url(${item.img})` } : null"
            >
              {{ item.title }}
            </a>
          </div>
        </div>
      </div> -->
      <!-- 中品动态 -->
      <div class="plate" style="margin-bottom: 240px">
        <div class="plate_left">
          <div class="title">中品动态</div>
          <div class="main_plate">
            <div class="zhongpin_left">
              <div
                class="zhongpin_left_item"
                :style="{
                  backgroundImage:
                    'url(' + dongTai.bannerList[0]?.cover_img + ')',
                }"
                @click="goToDetail(dongTai.bannerList[0]?.id)"
              ></div>
              <div
                class="zhongpin_left_item"
                :style="{
                  backgroundImage:
                    'url(' + dongTai.bannerList[1]?.cover_img + ')',
                }"
                @click="goToDetail(dongTai.bannerList[1]?.id)"
              ></div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="(item, index) in dongTai.newsList"
                :key="item.id || index"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <div
          class="plate_right"
          style="margin-top: 65px"
          v-if="dongTai.classSonList.length"
        >
          <div
            class="plate_right_item"
            v-for="(item, index) in dongTai.classSonList"
            :key="index"
          >
            <div class="plate_right_item_content">
              <a
                :href="item.url"
                target="_blank"
                class="plate_right_item_content_item"
              >
                <img :src="item.img" alt="" />
              </a>
            </div>
            <div class="laozihao_item_title">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerCarousel from "../components/BannerCarousel.vue";
import BackToTop from "../components/BackToTop.vue";
import { getIndexData } from "@/api";

import { imgBaseURL } from "@/api/index";

export default {
  name: "Home",
  components: {
    BannerCarousel,
    BackToTop,
  },
  data() {
    return {
      // 轮播图
      banners: [],
      // 热点新闻列表
      topNewsList: [],
      // 品牌热点
      reDian: {
        bannerList: [],
        newsList: [],
        classSonList: [],
      },
      // 合作
      heZuo: {
        imgList: [],
      },
      // 品牌出海
      chuHai: {
        bannerList: [],
        newsList: [],
        classSonList: [],
      },
      // 发布
      faBu: {
        imgList: [],
      },
      // 品牌
      pinPai: {
        bannerList: [],
        newsList: [],
        classSonList: [],
      },
      // 论坛
      lunTan: {
        bannerList: [],
        newsList: [],
        guanShuo: [],
      },
      // 报道
      baoDao: {
        imgList: [],
      },
      // 动态
      dongTai: {
        bannerList: [],
        newsList: [],
        classSonList: [],
      },
    };
  },
  mounted() {
    this.fetchIndexData();
  },
  methods: {
    async fetchIndexData() {
      try {
        const res = await getIndexData();
        if (res.code === 1 && res.data) {
          const data = res.data;
          // 轮播图 - shuang_yu.carousel_list
          this.banners = (data.shuang_yu?.carousel_list || []).map((item) => ({
            id: item.id,
            img: imgBaseURL + item.cover_img,
            title: item.title,
            title_en: item.title_en,
          }));
          // 热点文字列表 - shuang_yu.top_news_list
          this.topNewsList = data.shuang_yu?.top_news_list || [];

          // 品牌热点侧边栏 - re_dian.class_son_list
          this.reDian.classSonList = (data.re_dian?.class_son_list || []).map(
            (item) => ({
              name: item.name,
              img: imgBaseURL + item.img,
              url: item.url,
            })
          );
          // 品牌热点新闻列表 - re_dian.news_list
          this.reDian.newsList = data.re_dian?.news_list || [];
          // 品牌热点 banner 列表 - re_dian.banner_list
          this.reDian.bannerList = (data.re_dian?.banner_list || []).map(
            (item) => ({
              ...item,
              cover_img: imgBaseURL + item.cover_img,
            })
          );

          // 品牌出海侧边栏 - chu_hai.class_son_list
          this.chuHai.classSonList = (data.chu_hai?.class_son_list || []).map(
            (item) => ({
              name: item.name,
              img: imgBaseURL + item.img,
              url: item.url,
            })
          );
          // 品牌出海新闻列表 - chu_hai.news_list
          this.chuHai.newsList = data.chu_hai?.news_list || [];
          // 品牌出海 banner 列表 - chu_hai.banner_list
          this.chuHai.bannerList = (data.chu_hai?.banner_list || []).map(
            (item) => ({
              ...item,
              cover_img: imgBaseURL + item.cover_img,
            })
          );

          // 论坛 - lun_tan
          this.lunTan.bannerList = (data.lun_tan?.banner_list || []).map(
            (item) => {
              const bannerPath = item.cover_img ?? item.img;
              const bannerUrl = bannerPath ? imgBaseURL + bannerPath : "";
              return {
                ...item,
                img: bannerUrl,
                cover_img: bannerUrl,
              };
            }
          );
          this.lunTan.newsList = data.lun_tan?.news_list || [];
          this.lunTan.guanShuo = (data.lun_tan?.guan_shuo || []).map(
            (item) => ({
              ...item,
              img: imgBaseURL + item.img,
            })
          );

          // 老字号品牌侧边栏 - pin_pai.class_son_list
          this.pinPai.classSonList = (data.pin_pai?.class_son_list || []).map(
            (item) => ({
              name: item.name,
              img: imgBaseURL + item.img,
              url: item.url,
            })
          );
          // 老字号品牌新闻列表 - pin_pai.news_list
          this.pinPai.newsList = data.pin_pai?.news_list || [];
          // 老字号品牌 banner 列表 - pin_pai.banner_list
          this.pinPai.bannerList = (data.pin_pai?.banner_list || []).map(
            (item) => ({
              ...item,
              cover_img: imgBaseURL + item.cover_img,
            })
          );

          // 合作 - he_zuo.img_list
          this.heZuo = {
            img_list: (data.he_zuo?.img_list || []).map((item) => ({
              ...item,
              img: imgBaseURL + item.img,
            })),
          };

          // 发布 - fa_bu.img_list
          this.faBu = {
            img_list: (data.fa_bu?.img_list || []).map((item) => ({
              ...item,
              img: imgBaseURL + item.img,
            })),
          };

          // 专题报道 - bao_dao.img_list
          this.baoDao.imgList = (data.bao_dao?.img_list || [])
            .slice()
            .sort((a, b) => {
              const sa = Number(a.sort ?? 0);
              const sb = Number(b.sort ?? 0);
              if (sa !== sb) return sa - sb;
              const ia = Number(a.id ?? 0);
              const ib = Number(b.id ?? 0);
              return ia - ib;
            })
            .map((item) => ({
              ...item,
              img: item.img ? imgBaseURL + item.img : "",
            }));

          // 动态 - dong_tai
          this.dongTai = {
            bannerList: (data.dong_tai?.banner_list || []).map((item) => ({
              ...item,
              cover_img: item.cover_img ? imgBaseURL + item.cover_img : "",
            })),
            newsList: data.dong_tai?.news_list || [],
            classSonList: (data.dong_tai?.class_son_list || []).map((item) => ({
              name: item.name,
              img: imgBaseURL + item.img,
              url: item.url,
            })),
          };
        }
      } catch (error) {
        console.error("获取首页数据失败:", error);
      }
    },
    goToDetail(id) {
      if (id != null && id !== undefined && id !== "")
        window.open(
          this.$router.resolve({ name: "NewsDetail", params: { id } }).href,
          "_blank"
        );
    },
    getFullUrl(path) {
      if (!path) return "";
      return path.startsWith("http") ? path : imgBaseURL + path;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  max-width: 76rem;
  margin: 0 auto;
}
.main_plate_news {
  display: flex;
  flex-direction: column;
  // gap: 12px;
  max-width: 446px;
  span {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color 0.3s ease;
    line-height: 1.6;
  }
  .news1 {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #424242;
    cursor: pointer;
    padding: 4px 0;
    &:hover {
      color: #a90206;
    }
  }
  .news2 {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #424242;
    font-weight: bold;
    cursor: pointer;
    padding: 4px 0;
    &:hover {
      color: #a90206;
    }
  }
  .bold {
    font-weight: bold;
  }
}
.plate {
  display: flex;
  border-top: 1px solid #cdcdcd;
  padding-top: 24px;
  margin-top: 40px;
  box-sizing: border-box;
  justify-content: space-between;
  .title {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 24px;
    color: #a90206;
    margin-bottom: 40px;
    position: relative;
    padding-left: 12px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 20px;
      background: #a90206;
      border-radius: 2px;
    }
  }
  .zhuan_item {
    display: flex;
    flex-direction: column;
    .zhuan_item_content {
      display: flex;
      justify-content: space-between;
      .zhuan_item_box1 {
        width: 370px;
        height: 180px;
        background: #ececec;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 38px;
        color: #fff;
        text-align: center;
        line-height: 180px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
      .zhuan_item_box2 {
        width: 216px;
        height: 180px;
        background: #ececec;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 24px;
        color: #fff;
        text-align: center;
        line-height: 180px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
      .zhuan_item_box3 {
        width: 310px;
        height: 180px;
        background: #ececec;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 24px;
        color: #fff;
        text-align: center;
        line-height: 180px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        cursor: pointer;
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
      .zhuan_item_box_bg {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        text-decoration: none;
      }
    }
  }
  .zhongpin_left {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-right: 35px;
    .zhongpin_left_item {
      width: 370px;
      height: 196px;
      background: #b7b7b7;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      cursor: pointer;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .zhongpin_right {
    display: flex;
    flex-direction: column;
    gap: 12px;
    .zhongpin_right_item {
      width: 310px;
      height: 130px;
      background: #d7d7d7;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      cursor: pointer;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .laozihao_item_title {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    margin-top: 10px;
  }
  .plate_left {
    .main_plate {
      display: flex;

      .main_plate_item {
        display: flex;
        flex-direction: column;
        max-width: 370px;
        margin-right: 35px;
        .main_plate_itemTop {
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-bottom: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 239px;
            object-fit: cover;
            transition: transform 0.3s ease;
            cursor: pointer;
            &:hover {
              transform: scale(1.02);
            }
          }
          span {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-top: 15px;
            width: 100%;
            line-height: 1.6;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            transition: color 0.3s ease;
            &:hover {
              color: #a90206;
            }
          }
        }
        .main_plate_itemBottom {
          display: flex;
          gap: 12px;
          .main_plate_itemBottom_item {
            display: flex;
            flex-direction: column;
            width: 100%;
            cursor: pointer;
            img {
              width: 180px;
              height: 100px;
              object-fit: cover;
              transition: transform 0.3s ease;
              cursor: pointer;
              &:hover {
                transform: scale(1.03);
              }
            }
            span {
              font-family: SourceHanSansCN, SourceHanSansCN;
              font-weight: 400;
              font-size: 14px;
              color: #666666;
              margin-top: 12px;
              width: 100%;
              line-height: 1.6;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
              transition: color 0.3s ease;
              &:hover {
                color: #a90206;
              }
            }
          }
        }
      }
    }
  }
  .plate_right {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    gap: 30px;
    max-width: 320px;
    .plate_right_item {
      display: flex;
      flex-direction: column;
      .plate_right_item_title {
        margin-bottom: 20px;
        span {
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 500;
          font-size: 20px;
          color: #000000;
        }
      }
      .plate_right_item_content {
        display: flex;
        gap: 10px;
        .plate_right_item_content_item {
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            height: 169px;
            object-fit: cover;
            transition: transform 0.3s ease;
            cursor: pointer;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }
}

.zhuanti {
  display: flex;
  flex-direction: column;
}
.photo_banner {
  width: 100%;
  display: flex;
  align-items: stretch;
  margin: 86px 0 92px 0;
  gap: 0;
  .photo_banner_item {
    position: relative;
    margin: 0;
    padding: 0;
    overflow: hidden;
    img {
      display: block;
      margin: 0;
      padding: 0;
      transition: transform 0.3s ease;
    }
  }
  .photo_banner_headline {
    width: 80px;
    flex-shrink: 0;
    background-color: #ff3c00;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 262px;
    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }
  }
  .photo_banner_photo {
    flex: 1;
    margin: 0;
    padding: 0;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
    &:hover img {
      transform: scale(1.05);
    }
    .photo_text {
      position: absolute;
      left: 30px;
      top: 50px;
      padding-right: 30px;
      font-family: MicrosoftYaHei;
      font-size: 35px;
      box-sizing: border-box;
      color: #ffffff;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      z-index: 1;
    }
  }
}

/* 平板端：宽度 <= 1200px 时的布局调整 */
@media (max-width: 1200px) {
  .container {
    max-width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .plate {
    flex-direction: column;
    gap: 32px;
    margin-top: 32px;
    padding-top: 24px;

    .plate_left,
    .plate_right {
      width: 100%;
      margin-top: 0;
    }

    .plate_left {
      .main_plate {
        flex-direction: column;
        gap: 24px;
      }
    }

    .main_plate_item {
      max-width: 100% !important;
      margin-right: 0 !important;
    }

    .main_plate_itemBottom {
      .main_plate_itemBottom_item {
        img {
          width: 100% !important;
          height: auto !important;
          max-height: 200px;
        }
      }
    }

    .main_plate_news {
      max-width: 100%;
      margin-top: 24px;
    }

    .plate_right {
      margin-top: 0;
      gap: 24px;
      max-width: 100%;
      .plate_right_item_content {
        flex-wrap: wrap;
      }
    }

    .zhongpin_left,
    .zhongpin_right {
      width: 100%;
      margin-right: 0 !important;
    }

    .zhongpin_left .zhongpin_left_item,
    .zhongpin_right .zhongpin_right_item {
      width: 100%;
    }
  }

  .photo_banner {
    gap: 12px;
    margin: 60px 0 70px 0;

    .photo_banner_headline {
      width: 80px;
      background-color: #ff3c00;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 187px;
      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
    }
    .photo_banner_photo {
      .photo_text {
        font-size: 25px;
      }
    }
  }
}

/* 移动端：宽度 <= 768px 时的布局调整 */
@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }

  .main_plate_news {
    gap: 10px;
    max-width: 100%;

    .news1,
    .news2 {
      font-size: 15px;
      line-height: 1.8;
      padding: 6px 0;
    }
  }

  .plate {
    padding-top: 20px;
    margin-top: 24px;

    .title {
      font-size: 20px;
      margin-bottom: 24px;
      padding-left: 10px;
      &::before {
        width: 3px;
        height: 16px;
      }
    }

    .zhuan_item {
      margin-bottom: 24px !important;
      .zhuan_item_content {
        flex-direction: column;
        gap: 12px;

        .zhuan_item_box1,
        .zhuan_item_box2,
        .zhuan_item_box3 {
          width: 100%;
          height: 160px;
        }
        .zhuan_item_box1 {
          line-height: 160px;
          font-size: 32px;
        }
      }
    }

    .main_plate {
      flex-direction: column;
      gap: 20px;
    }

    .main_plate_item {
      max-width: 100%;
      margin-right: 0;
    }

    .main_plate_itemTop {
      margin-bottom: 16px;
      img {
        height: 200px;
      }
      span {
        margin-top: 12px;
        font-size: 15px;
      }
    }

    .main_plate_itemBottom {
      flex-direction: column;
      gap: 16px;
      .main_plate_itemBottom_item {
        img {
          width: 100% !important;
          height: auto !important;
          max-height: 180px;
        }
        span {
          margin-top: 10px;
          font-size: 15px;
        }
      }
    }

    .plate_right {
      gap: 20px;
      margin-top: 0;
      max-width: 100%;
      .plate_right_item_title {
        margin-bottom: 16px;
        span {
          font-size: 18px;
        }
      }
      .plate_right_item_content {
        .plate_right_item_content_item {
          img {
            height: 140px;
          }
        }
      }
    }
  }

  .zhuanti {
    margin-bottom: 40px !important;
  }

  .photo_banner {
    flex-direction: column;
    align-items: stretch;
    margin: 32px 0;
    gap: 12px;

    .photo_banner_headline {
      width: 100%;
      background-color: #ff3c00;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
    }

    .photo_banner_photo {
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
        min-height: 200px;
        object-fit: cover;
      }
      .photo_text {
        left: 16px;
        top: 20px;
        font-size: 14px;
        padding-right: 16px;
      }
    }
  }

  .zhongpin_left,
  .zhongpin_right {
    margin-right: 0 !important;
    gap: 16px;
  }

  .zhongpin_left .zhongpin_left_item {
    height: 160px;
  }

  .zhongpin_right .zhongpin_right_item {
    height: 100px;
  }
}
</style>
